import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DayOrdersStatistics } from '@api/shipping-data/types/DayOrdersStatistics';
import { StatisticModel } from '@pages/preview/cards-area/StatisticModel';
import { convertToStatisticModel } from '@pages/preview/store/convertors';



interface PreviewState {
	statisticModel: StatisticModel | null
};

const initialState: PreviewState = {
	statisticModel: null
};



export const previewSlice = createSlice({
	name: 'preview',
	initialState,
	reducers: {
		createStatisticModel: (state, action: PayloadAction<DayOrdersStatistics | null | undefined>) => {
			let createdResult = convertToStatisticModel(action.payload);
			state.statisticModel = createdResult;
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createStatisticModel,
	resetStore } = previewSlice.actions;